/**
 * Pending (dirty) Paramate params.
 *
 * `setParamValue(name, value, false)` writes the value into the SDK's param
 * table and flags the param `dirty`, but sends nothing. The SDK gathers those
 * dirty entries in exactly one place — inside `setParamValue` itself, when it
 * is the one triggering the configure. `configure()` sends whatever map it is
 * handed, verbatim, so a bare `configure()` is an empty PUT and the staged
 * edits never leave the client.
 *
 * These helpers are that gather step, pulled out so we can send the pending
 * values ourselves. Both `configure()` and `restoreSession()` replace the whole
 * param table with the server's response, which clears the flags — so dirty
 * entries are exactly the edits no configure has flushed yet.
 */

/** Flat `{ "pkg:param": value }` map of the pending params. Values are live
 *  references, not clones. */
export function getPendingParams(configurator: any): Record<string, any> {
  const params = configurator?.params ?? {};
  const pending: Record<string, any> = {};
  for (const [key, param] of Object.entries(params)) {
    if ((param as any)?.dirty) pending[key] = (param as any).value;
  }
  return pending;
}

/** The same params in Paramate's changes format, ready to hand to `configure()`. */
export function pendingParamChanges(configurator: any): Record<string, { value: any }> {
  const changes: Record<string, { value: any }> = {};
  for (const [key, value] of Object.entries(getPendingParams(configurator))) {
    changes[key] = { value };
  }
  return changes;
}
